import { render, staticRenderFns } from "./HuashuEdit.vue?vue&type=template&id=796f2a67&scoped=true"
import script from "./HuashuEdit.vue?vue&type=script&lang=js"
export * from "./HuashuEdit.vue?vue&type=script&lang=js"
import style0 from "./HuashuEdit.vue?vue&type=style&index=0&id=796f2a67&prod&lang=css"
import style1 from "./HuashuEdit.vue?vue&type=style&index=1&id=796f2a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f2a67",
  null
  
)

export default component.exports